var render, staticRenderFns
import script from "./damagelist.vue?vue&type=script&lang=js&"
export * from "./damagelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497c18f0",
  null
  
)

export default component.exports